import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import { obtenerSolicitudesEntregas } from '../../../redux/DuckPanelHologramas/ModuloEntregasDuck';
import React, { Fragment, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { Tab, Tabs } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Button from '@mui/material/Button'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { ObtenerSolicitudesFC_40ConsultaAC } from '../../../redux/DuckPanelHologramas/ModuloComprasDuck';
import ModalHistorialComponent from './HistorialCompras/ModalHistorialComponent';
import ModalEntregasParcialesComponent from './HistorialEntrega/ModalEntregasParcialesComponent';
import { entregasParciales } from '../../../redux/DuckPanelHologramas/ModuloInventarioDuck';
import PanelInventarioComponent from './Inventario/PanelInventariosComponent';

const PanelConsultaHologramasDGComponent = () => {

    const dispatch = useDispatch()

    const solicitudesentregas = useSelector(store => store.ModuloEntregas.data)
    const solicitudesCompra = useSelector(store => store.ModuloCompras.data)

    const [value, setValue] = React.useState("1");
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    React.useEffect(async () => {
        if (value == '1') await dispatch(ObtenerSolicitudesFC_40ConsultaAC())
        if (value == '2') await dispatch(obtenerSolicitudesEntregas())
    }, [value])

    const [openModalEntregas, setOpenModalEntregas] = React.useState(false)
    const [dataEntrega, setDataEntrega] = React.useState([])
    const columnsEntrega = [
        { field: 'numSolicitud', headerName: 'No. solicitud', headerAlign: 'center', width: 130 },
        { field: 'numAsociado', headerName: 'No. de asociado', headerAlign: 'center', width: 130 },
        { field: 'fecha', headerName: 'Fecha', headerAlign: 'center', width: 120 },
        { field: 'razonSocial', headerName: 'Razón social', headerAlign: 'center', width: 350 },
        { field: 'inventario', headerName: 'Inventario', headerAlign: 'center', width: 100 },
        { field: 'solicitado', headerName: 'Solicitado', headerAlign: 'center', width: 100 },
        { field: 'producto', headerName: 'Producto', headerAlign: 'center', width: 150 },
        {
            field: 'estatus', headerName: 'Estatus', headerAlign: 'center', width: 150,
            renderCell: (params) =>
                params.row.isEntrega ?
                    params.row.estatus != 'Por Atender' ? <ThemeProvider theme={theme}> <Button variant="contained" color="primary" style={{ width: '80%' }} onClick={() => detalleEntrega(params.row.idinformacionentrega)}>{params.row.estatus}</Button> </ThemeProvider> :
                        params.row.estatus :
                    params.row.estatus != 'Por Atender' ? <ThemeProvider theme={theme}> <Button variant="contained" color="primary" style={{ width: '80%' }} onClick={() => detalleEntrega(params.row.idinformacionentrega)}>{params.row.estatus}</Button> </ThemeProvider> :
                        params.row.estatus
        },
    ]
    const rowsEntrega = []
    solicitudesentregas?.fc_09_solicitudemicioncertificadonomexportacionyentregahologram?.map(anexo => {
        let inventario = false
        let sumaBotella = 0
        for (const i in anexo.fc_09_anexoproducto) {
            sumaBotella += anexo?.fc_09_anexoproducto?.[i]?.numerobotellas
        }

        let isInvetario = false
        let isEntrega = false
        if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas.length > 0) {
            isInvetario = true
            let inventarioMezcal = 0
            if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal == '' ||
                anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal == '0') inventarioMezcal = 0
            else inventarioMezcal = Number(anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal)
            if (sumaBotella > inventarioMezcal) isEntrega = true
        } else {
            isInvetario = false
            isEntrega = true
        }
        let estatus = ''
        let idinformacionentrega = 0

        if (anexo?.informacionentregahologramas?.length == 0) estatus = 'Por Atender'
        else {
            if (anexo?.informacionentregahologramas?.[0]?.idestatusentrega == 1) { estatus = 'Parcial' }
            else { estatus = 'completado' }

            idinformacionentrega = anexo?.informacionentregahologramas?.[0]?.idinformacionentrega
        }

        rowsEntrega.push({
            id: uuidv4(), numSolicitud: '', numAsociado: anexo?.numerocliente,
            fecha: anexo?.fechasolicitud?.substring(0, 10), razonSocial: anexo?.nombrecliente,
            producto: 'Exportación', isInvetario: isInvetario, isEntrega: isEntrega,
            inventario: anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal,
            solicitado: sumaBotella, estatus: estatus, idlogin: anexo?.login?.idlogin, idinformacionentrega: idinformacionentrega
        })
    })

    solicitudesentregas?.fc_33_solicitudenvasadonacional?.map(anexo => {
        let inventario = false
        let sumaBotella = 0
        for (const i in anexo.fc_33_anexoproducto) {
            sumaBotella += Number(anexo?.fc_33_anexoproducto?.[i]?.numerobotellas)
        }
        let isInvetario = false
        let isEntrega = false
        if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas.length > 0) {
            isInvetario = true
            let inventarioMezcal = 0
            if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal == '' ||
                anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal == '0') inventarioMezcal = 0
            else inventarioMezcal = Number(anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal)
            if (sumaBotella > inventarioMezcal) isEntrega = true
        }
        else {
            isInvetario = false
            isEntrega = true
        }
        let estatus = ''
        let idinformacionentrega = 0
        if (anexo?.informacionentregahologramas?.length == 0) estatus = 'Por Atender'
        else {
            if (anexo?.informacionentregahologramas?.[0]?.idestatusentrega == 1) { estatus = 'Parcial' }
            else { estatus = 'completado' }
            idinformacionentrega = anexo?.informacionentregahologramas?.[0]?.idinformacionentrega
        }

        rowsEntrega.push({
            id: uuidv4(), numSolicitud: '', numAsociado: anexo?.numerocliente,
            fecha: anexo?.fechasolicitud?.substring(0, 10), razonSocial: anexo?.nombrecliente,
            producto: 'Nacional', isInvetario: isInvetario, isEntrega: isEntrega,
            inventario: anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal,
            solicitado: sumaBotella, estatus: estatus, idlogin: anexo?.login?.idlogin,
            idinformacionentrega: idinformacionentrega
        })
    })

    solicitudesentregas?.fc_41_solicitudparabebidasconmezcal?.map(anexo => {
        let isInvetario = false
        let isEntrega = false
        let sumaBotella = 0
        for (const i in anexo.fc_41_anexoproducto) {
            sumaBotella += Number(anexo?.fc_41_anexoproducto?.[i]?.numerobotellas)
        }
        if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas.length > 0) {
            isInvetario = true
            let inventarioBebidasMezcal = 0
            if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasbebidas == '' ||
                anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasbebidas == '0') inventarioBebidasMezcal = 0
            else inventarioBebidasMezcal = Number(anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasbebidas)
            if (sumaBotella > inventarioBebidasMezcal) isEntrega = true
        } else {
            isInvetario = false
            isEntrega = true
        }
        let estatus = ''
        let idinformacionentrega = 0
        if (anexo?.informacionentregahologramas?.length == 0) estatus = 'Por Atender'
        else {
            if (anexo?.informacionentregahologramas?.[0]?.idestatusentrega == 1) { estatus = 'Parcial' }
            else { estatus = 'completado' }
            idinformacionentrega = anexo?.informacionentregahologramas?.[0]?.idinformacionentrega
        }

        rowsEntrega.push({
            id: uuidv4(), numSolicitud: '', numAsociado: anexo?.numerocliente,
            fecha: anexo?.fechasolicitud?.substring(0, 10), razonSocial: anexo?.nombrerazonsocial,
            producto: 'Bebidas con Mezcal', isInvetario: isInvetario, isEntrega: isEntrega,
            inventario: anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasbebidas,
            solicitado: sumaBotella, estatus: estatus, idlogin: anexo?.login?.idlogin,
            idinformacionentrega: idinformacionentrega
        })
    })

    const detalleEntrega = async (idinformacionentrega) => {
        let result = await dispatch(entregasParciales(idinformacionentrega))
        if (result?.payload != undefined && result?.payload != null && result?.payload?.length > 0) {
            setDataEntrega(result.payload)
            setOpenModalEntregas(true)
        }
    }





    const [openModalCompra, setOpenModalCompra] = React.useState(false)
    const [dataCompra, setDataCompra] = React.useState([])

    const columnsCompra = [
        { field: 'numFolio', headerName: 'Núm. de folio', headerAlign: 'center', width: 150 },
        { field: 'numAsociado', headerName: 'No. de asociado', headerAlign: 'center', width: 150 },
        { field: 'fecha', headerName: 'Fecha', headerAlign: 'center', width: 150 },
        { field: 'razonSocial', headerName: 'Razón social', headerAlign: 'center', width: 430 },
        { field: 'producto', headerName: 'Producto', headerAlign: 'center', width: 208 },
        {
            field: 'accion', headerName: 'Estatus', headerAlign: 'center', width: 135,
            renderCell: (params) =>
            (
                params.row.estatus == 'Terminada' ?
                    <ThemeProvider theme={theme}>
                        <Button variant="contained" color="primary" style={{ width: '85%' }} onClick={() => detallecompra(params)}>Confirmado</Button>
                    </ThemeProvider>
                    :
                    <div className='text-center'>{params.row.estatus}</div>
            )
        },
    ];

    const rowsCompra = [];
    solicitudesCompra?.map(anexo => {

        let combinacionProducto = ''
        if (anexo.hologramasmezcal && anexo.hologramasbebidasmezcal) combinacionProducto = 'Mezcal y bebidas con mezcal'
        else if (anexo.hologramasmezcal) combinacionProducto = 'Mezcal'
        else if (anexo.hologramasbebidasmezcal) combinacionProducto = 'Bebidas con mezcal'
        let estatus = ''
        if (anexo?.isatendidafinanzas == false && anexo?.isatendidahologramas == false) estatus = 'En finanzas'

        if (anexo?.isatendidafinanzas == true && anexo?.isatendidahologramas == false) estatus = 'En Hologramas'
        if (anexo?.isatendidafinanzas == true && anexo?.isatendidahologramas == true) estatus = 'Terminada'

        rowsCompra.push({
            id: uuidv4(), numFolio: anexo.folio, numAsociado: anexo.numerocliente, fecha: anexo.fechasolicitud.substring(0, 10),
            razonSocial: anexo.nombrerazonsocial, producto: combinacionProducto, idfc40_solicitudadquisicionholo: anexo.idfc40_solicitudadquisicionholo,
            estatus: estatus, solicitudescomprashologramas: anexo.solicitudescomprashologramas, cantidadmezcal: anexo.cantidadmezcal,
            cantidadbebidasmezcal: anexo.cantidadbebidasmezcal
        })
    })

    const detallecompra = (params) => {
        setOpenModalCompra(true)
        setDataCompra(params.row.solicitudescomprashologramas)
    }

    const theme = createTheme({
        palette: {
            primary: {
                main: "#7D9A47"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                    mb: 2,
                    textAlign: 'left',
                    height: 30,
                    width: '100%',
                    backgroundColor: 'white'
                }}>
                <ThemeProvider theme={theme}>
                    <GridToolbarQuickFilter style={{ backgroundColor: '#F4F6F6', width: '100%', fontFamily: 'Montserrat' }} placeholder='Búsqueda...' />
                </ThemeProvider>
            </Box>
        );
    }

    return (
        <div className="container mt-4" style={{ fontFamily: 'Montserrat' }}>
            <h3 className='text-center tm'><b>MODULO CONSULTA DE HOLOGRAMAS</b></h3><br />
            <div className='text-center'>
                <Box className='text-center'>
                    <TabContext value={value}>
                        <Box sx={{
                            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                            textAlign: 'center', backgroundColor: '#fcfcfc',
                            boxShadow: '0 0px 16px 0px rgba(0, 0, 0, 0.3)', height: '60px', borderRadius: '8px'
                        }}>
                            <TabList onChange={handleChange} aria-label="visible arrows tabs example" variant="scrollable" scrollButtons="auto" className='text-center'
                                TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                                sx={{
                                    "& button": { color: '#7D9A47', fontFamily: 'Montserrat', fontWeight: 'bold' },
                                    "& button:hover": { color: '#7D9A47', transform: 'scale(1.1)' },
                                    "& button.Mui-selected": { backgroundColor: '#7D9A47', color: 'white', borderTopLeftRadius: 9, borderTopRightRadius: 9, borderBottomLeftRadius: 9, borderBottomRightRadius: 9 }
                                }}>
                                <Tab label="COMPRAS" value="1" />
                                <Tab label="ENTREGAS" value="2" />
                                <Tab label="INVENTARIO" value="3" />
                            </TabList>
                        </Box>
                        <TabPanel value="1">
                            <Box sx={{ height: 530, width: '100%' }}>
                                <DataGrid
                                    rows={rowsCompra}
                                    columns={columnsCompra}
                                    disableColumnMenu={true}
                                    components={{ Toolbar: QuickSearchToolbar }}
                                    getRowHeight={() => 'auto'}
                                    pageSize={10}
                                    sx={{
                                        boxShadow: 0,
                                        color: 'black',
                                        border: 0,
                                        backgroundColor: 'white',
                                        fontFamily: 'Montserrat',
                                        '& .MuiDataGrid-cell': {
                                            display: 'block',
                                            position: 'relative',
                                            textAlign: 'center',
                                            paddingTop: '15px',
                                            paddingBottom: '15px',
                                            paddingLeft: 0,
                                            paddingRight: 0
                                        },
                                        '& .MuiDataGrid-columnHeaders': {
                                            backgroundColor: '#0C365A',
                                            color: 'white',
                                            fontFamily: 'Montserrat',
                                            fontWeight: 'bold',
                                            height: '20px'
                                        }
                                    }}
                                />
                            </Box>
                        </TabPanel>
                        <TabPanel value="2">
                            <Box sx={{ height: 600, width: '100%', }}>
                                <DataGrid
                                    rows={rowsEntrega}
                                    initialState={{ sorting: { sortModel: [{ field: 'fecha', sort: 'desc' }], }, }}
                                    columns={columnsEntrega}
                                    disableColumnMenu={true}
                                    components={{ Toolbar: QuickSearchToolbar }}
                                    rowsPerPageOptions={[]}
                                    getRowHeight={() => 'auto'}
                                    getRowClassName={(params) => {
                                        if (params.row.isEntrega) return "alertaRoja"
                                    }}
                                    sx={{
                                        boxShadow: 0,
                                        color: 'black',
                                        border: 0,
                                        backgroundColor: 'white',
                                        fontFamily: 'Montserrat',
                                        '& .MuiDataGrid-cell': {
                                            display: 'block',
                                            position: 'relative',
                                            textAlign: 'center',
                                            paddingTop: '15px',
                                            paddingBottom: '15px',
                                            paddingLeft: 0,
                                            paddingRight: 0
                                        },
                                        '& .MuiDataGrid-columnHeaders': {
                                            backgroundColor: '#0C365A',
                                            color: 'white',
                                            fontFamily: 'Montserrat',
                                            fontWeight: 'bold',
                                            height: '20px'
                                        },
                                        ".alertaRoja": {
                                            background: '#FA9696',
                                            border: '2px solid #FF7F7F',
                                            "&:hover": {
                                                background: "#FF7F7F"
                                            }
                                        },
                                    }}
                                />
                            </Box>
                        </TabPanel>
                        <TabPanel value="3" >
                            <PanelInventarioComponent />
                        </TabPanel>
                    </TabContext>
                </Box>
            </div>
            {openModalCompra &&
                <ModalHistorialComponent setOpenModalCompra={{ setOpenModalCompra }} historial={dataCompra}></ModalHistorialComponent>
            }
            {openModalEntregas &&
                <ModalEntregasParcialesComponent setOpenModalEntregas={{ setOpenModalEntregas }} historial={dataEntrega} />
            }

        </div>
    );
};
export default PanelConsultaHologramasDGComponent